import jwtDecode from "jwt-decode";
import { toast } from "react-toastify";
import setAuthToken from "utils/setAuthToken";
import "components/auth/axios-modified";

import { authenticateUser, authenticateCustomer } from "api/authApi";
import { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";

import {
    SET_CURRENT_USER,
} from "actions/types";

// Set logged in user
export const setCurrentUser = decoded => ({
  type: SET_CURRENT_USER,
  payload: decoded
});

// Login - Get User Token
export const loginUser = (userData) => dispatch => {
    dispatch(formErrorLoading());
    authenticateUser(userData.employeeCode, userData.password)
        .then(response => {
            dispatch(formErrorLoading(false));
            // Save to localStorage
            const {
                token,
                refreshToken
            } = response.data;
            // Set token to ls
            localStorage.setItem("jwtToken", token);
            localStorage.setItem("refreshToken", refreshToken);
            // Set token to Auth header
            setAuthToken(token);
            // Decode token to get user data
            const user = jwtDecode(token);
            // Set current user
            dispatch(setCurrentUser(user));

            toast("You are logged in successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch((error) => {
            dispatch(formErrorLoading(false));
            defaultErrorHandler(error);
        });
};

export const loginCustomer = (userData) => dispatch => {
    dispatch(formErrorLoading());
    authenticateCustomer(userData.employeeCode, userData.password)
        .then(response => {
            dispatch(formErrorLoading(false));
            // Save to localStorage
            const {
                token,
                refreshToken
            } = response.data;
            // Set token to ls
            localStorage.setItem("jwtToken", token);
            localStorage.setItem("refreshToken", refreshToken);
            // Set token to Auth header
            setAuthToken(token);
            // Decode token to get user data
            const user = jwtDecode(token);
            // Set current user
            dispatch(setCurrentUser(user));

            toast("You are logged in successfully", {
                type: toast.TYPE.SUCCESS,
            });
        })
        .catch((error) => {
            dispatch(formErrorLoading(false));
            defaultErrorHandler(error);
        });
};

// Log user out
export const logoutUser = () => dispatch => {
    // Remove token from localStorage
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("refreshToken");
    // Remove auth header for future requests
    setAuthToken(false);
    // Set current user to {} which will set isAuthenticated to false
    dispatch(setCurrentUser({}));
};
